import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="w-full rounded-2xl border border-orange-200 bg-orange-50 p-4" data-id="element-289" data-mp="2l5ppm8bj0cdm">
      <div className="flex items-center justify-between gap-3" data-id="element-290" data-mp="2q3r4eh1x5pja">
        <p className="flex items-center gap-2 text-[14px] font-bold text-orange-900 sm:text-[15px]" data-id="element-291" data-mp="2q1wjh2qndxf7">
          <FlameIcon className="h-5 w-5 shrink-0 text-orange-600" aria-hidden="true" data-id="element-292" data-mp="2b8ut1uytcm1z" />
          Only {SPOTS_LEFT} spots left at the promotional price
        </p>
        <span className="shrink-0 text-sm font-extrabold text-orange-700" data-id="element-293" data-mp="227dewi4yuufx">{Math.round(filled)}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-orange-200" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(filled)} aria-label="Promotional spots claimed" data-id="element-294" data-mp="275on6ofm4ww1">
        <div className="h-full rounded-full bg-[repeating-linear-gradient(45deg,#EA580C_0,#EA580C_10px,#F97316_10px,#F97316_20px)]" style={{
        width: `${filled}%`
      }} data-id="element-295" data-mp="33m3a75pch7dv" />
      </div>
      <p className="mt-2 text-[12px] font-medium text-orange-800" data-id="element-296" data-mp="3dbmumfsph9au">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} promotional spots already claimed. The price returns to normal once they’re gone.
      </p>
    </div>;
}